import styled from 'styled-components';

const Table = styled.table`
   width: calc(100% + 2em);
   margin-left: -1em;

   font-family: var(--heading-font);

   thead {
      color: var(--brand-green);
   }

   th,
   td {
      padding: 0.25em 1em;
      text-align: left;
      vertical-align: middle;

      &:first-child {
         border-radius: 1em 0 0 1em;
      }
      &:last-child {
         border-radius: 0 1em 1em 0;
      }
   }

   &.row-hover tbody tr:hover {
      background: #8fd1d150;
   }

   .mini-progress-wrapper {
      display: flex;
      align-items: center;
   }

   .progress-indicator {
      width: 20px;
      margin-right: 0.5em;

      .progress-indicator-background,
      .progress-indicator-foreground {
         stroke-width: 20;
      }
   }

   .exercise-actions-cell {
      text-align: center;
      width: 6em;

      a {
         margin-right: 0.5em;
      }

      a:last-child {
         margin-right: 0;
      }
   }

   .exercise-level-label {
      margin-right: 0.5em;
   }

   .exercise-no-accuracy {
      color: var(--brand-light-green);
   }

   .progress-accuracy,
   .exercise-no-accuracy {
      font-size: 1em;
      margin-bottom: 0;
      width: 6.5em;
      text-align: right;
   }

   .exercise-locked {
      color: var(--brand-light-green);
   }

   @media (prefers-color-scheme: dark) {
      .exercise-locked {
         color: var(--brand-dark-green);
      }
   }

   a {
      color: var(--text-color);
      text-decoration: none;

      outline: none;
      border: none;
      background: none;
      padding: 0;
      cursor: pointer;

      :disabled {
         cursor: not-allowed;
         opacity: 0.3;
      }

      &:focus-visible,
      &:active,
      &:hover {
         :not(:disabled) {
            color: var(--brand-orange);
         }
      }
   }

   .icon-link {
      height: 1.5em;
   }

   @media (prefers-color-scheme: dark) {
      .exercise-no-accuracy {
         color: var(--brand-dark-green);
      }

      &.row-hover tbody tr:hover {
         background: #00000030;
      }

      a {
         &:focus-visible,
         &:active,
         &:hover {
            :not(:disabled) {
               color: var(--brand-orange);
            }
         }
      }
   }
`;

export { Table };
